import { Fetcher } from "@/utils/fetcher";

const common = new Fetcher();

export type ModeratorActionType = "create" | "update" | "delete";

export interface ModeratorRequestPayload {
  entity_type: string;
  entity_id: number;
  action_type: ModeratorActionType;
  requested_updated_data: unknown;
}

export interface ModeratorRequestResponse {
  Success: boolean;
  Message: string;
  Data?: unknown;
}

/**
 * POST /moderator-request
 * Creates a moderated update request (admin only). The backend injects
 * `request_by` from the authenticated admin session and snapshots the
 * current entity data (`old_data`) before storing the request for
 * moderator approval.
 */
export const createModeratorRequest = (payload: ModeratorRequestPayload) =>
  common.post<ModeratorRequestResponse>("/moderator-request", payload);
